import { render } from "./accountButton.vue?vue&type=template&id=ae0f0688&scoped=true&ts=true"
import script from "./accountButton.vue?vue&type=script&lang=ts"
export * from "./accountButton.vue?vue&type=script&lang=ts"

import "./accountButton.vue?vue&type=style&index=0&id=ae0f0688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0f0688"]])

export default __exports__